import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "@/components/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { apiClient } from "@/api/client";
import { tokenCache } from "@/utils/token-cache";

/* global document, Office, module, HTMLElement */

apiClient.setTokenProvider(() => tokenCache.getAccessToken());

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

const queryClient = new QueryClient();

const renderApp = () => {
  root?.render(
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <FluentProvider theme={webLightTheme} style={{ width: "100%", minWidth: 0 }}>
          <App />
        </FluentProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

if (typeof Office !== "undefined" && Office.onReady) {
  Office.onReady(() => {
    renderApp();
  });
} else {
  renderApp();
}

if ((module as any).hot) {
  (module as any).hot.accept("@/components/App", () => {
    renderApp();
  });
}
